import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import config from './config';
import 'nprogress/nprogress.css'; // progress bar style
import './assets/css/index.scss';
// 复写element轻提醒  保证页面最多一个
import { message } from '@/utils/validate';
//弹出框
import myConfirm from '@/components/myConfirm/myConfirm.js';
// ElementUI.Dialog.props.closeOnClickModal.default = false; //点击蒙层是否关闭
Vue.use(myConfirm);

import '@/assets/iconfont/iconfont.css';
import '@/assets/iconfont/iconfont.js';
import '@/assets/css/animate.css';
//
import 'element-ui/lib/theme-chalk/index.css';
//加密算法
import JsEncrypt from './utils/Rsa2.js';
//swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
// If you use Swiper 6.0.0 or higher
// import 'swiper/swiper-bundle.css';
Vue.prototype.$JsEncrypt = JsEncrypt;
//加密md5
import md5 from 'js-md5';
// import { getUrlParam } from './utils';
// try {
//   let _token = getUrlParam('_token'),
//     _SESSION = getUrlParam('_SESSION');
//   if (_token && _token.length) {
//     window._token = _token;
//   }
// } catch (e) {}

Vue.prototype.$md5 = md5;

Vue.use(VueAwesomeSwiper);
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$msg = message;
// 滑块插件
import SlideVerify from 'vue-monoplasty-slide-verify';

Vue.use(SlideVerify);

// import BtnControl from "./directive/btnControl";

// Vue.use(BtnControl);

// 权限指令,对按钮权限的控制

//-------递归遍历buttonList

import axios from 'axios';
// 挂载到vue原型链上
Vue.prototype.axios = axios;

(async () => {
  let res = await config();

  Vue.prototype.$conf = res;
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
})();
